import type { Dict } from "../en";

export const chat: Dict["chat"] = {
  // The conversation's header and its menus.
  rename: "Đổi tên",
  chatName: "Tên cuộc trò chuyện",
  searchChannel: "Tìm trong kênh này",
  searchConversation: "Tìm trong cuộc trò chuyện này",
  searchFailed: "Chưa tìm được lúc này.",
  searching: "Đang tìm…",
  nothingFound: "Không tìm thấy gì.",
  notifications: "Thông báo",
  notificationsTitle: "Thông báo: {level}",
  levelAll: "Tất cả tin nhắn",
  levelAllHint: "Mọi thứ có thể gửi đến bạn",
  levelMentions: "Chỉ khi được nhắc đến",
  levelMentionsHint: "@bạn, nhóm của bạn, @everyone, các luồng của bạn",
  levelNone: "Không nhận gì",
  levelNoneHint: "Chỉ hiện số chưa đọc",
  levelAllToast: "Nhận tất cả tin nhắn từ đây",
  levelMentionsToast: "Từ đây chỉ nhận lượt nhắc đến và các luồng của bạn",
  levelNoneToast: "Không nhận gì từ đây: chỉ hiện số chưa đọc",
  // `{phrase}` is the bold "off the record" (the words the server looks for stay English).
  listening:
    "Vantage lắng nghe ở đây để ghi nhớ cho nhóm. Bắt đầu tin nhắn bằng {phrase} để Vantage bỏ qua.",
  manage: "Quản lý",
  channelSettings: "Cài đặt kênh",
  everyoneAtBusyCube: "Mọi người ở Busy Cube",
  teamName: "Nhóm {name}",
  members_one: "{n} thành viên",
  members_other: "{n} thành viên",
  membersLabel: "Thành viên",
  needsAttention: "{n} cần xử lý",
  teamNotes: "Ghi chú nhóm",
  files: "Tệp",
  directMessage: "Tin nhắn riêng",
  online: "Trực tuyến",
  away: "Vắng mặt",
  offline: "Ngoại tuyến",
  markUnread: "Đánh dấu chưa đọc",
  markedUnread: "Đã đánh dấu chưa đọc",
  hideConversation: "Ẩn cuộc trò chuyện",
  hiddenUntilNext: "Đã ẩn đến khi có tin nhắn mới",
  pin: "Ghim",
  unpin: "Bỏ ghim",
  pinTitle: "Ghim lên đầu",
  pinnedTitle: "Đã ghim: đứng đầu danh sách tin nhắn riêng của bạn",
  newChat: "Cuộc trò chuyện mới",
  renameChat: "Đổi tên cuộc trò chuyện",
  pinChat: "Ghim cuộc trò chuyện",
  unpinChat: "Bỏ ghim cuộc trò chuyện",
  archiveChat: "Lưu trữ cuộc trò chuyện",
  chatArchived: "Đã lưu trữ cuộc trò chuyện",
  restoreChat: "Khôi phục cuộc trò chuyện",
  chatRestored: "Đã khôi phục cuộc trò chuyện",
  deleteChat: "Xóa cuộc trò chuyện",
  deleteChatTitle: "Xóa cuộc trò chuyện này?",
  deleteChatBody:
    "“{title}” sẽ bị xóa: các tin nhắn, câu trả lời của Vantage, cùng các tệp và báo cáo trong đó. Sau vài giây nữa sẽ không hoàn tác được.",
  alsoForget: "Quên luôn những gì Vantage đã biết về bạn ở đây",
  chatDeleted: "Đã xóa cuộc trò chuyện",
  chatDeleteFailed: "Không xóa được cuộc trò chuyện.",
  chatsArchiveFailed: "Không lưu trữ được các cuộc trò chuyện.",
  chatsDeleteFailed: "Không xóa được các cuộc trò chuyện.",
  chatsBusy_one: "{n} cuộc trò chuyện chưa đổi được vì Vantage đang trả lời.",
  chatsBusy_other: "{n} cuộc trò chuyện chưa đổi được vì Vantage đang trả lời.",
  privateChat: "Trò chuyện riêng với Vantage",
  archivedPrivateChat: "Đã lưu trữ · trò chuyện riêng với Vantage",
  inbox: "Hộp thư",
  relaySub: "Câu trả lời của bạn được gửi lại cho họ · bắt đầu bằng “Vantage,” để hỏi Vantage",
  fromInbox: "Từ Hộp thư của bạn",

  // The conversation page.
  conversation: "Cuộc trò chuyện",
  conversationGone: "Cuộc trò chuyện này không còn truy cập được",
  conversationGoneBody: "Có thể nó đã bị xóa, hoặc bạn không tham gia cuộc trò chuyện này.",
  backToChat: "Quay lại Trò chuyện",
  whatThisConversation: "cuộc trò chuyện này",
  whatMessages: "tin nhắn",
  channelAria: "Kênh #{slug}",
  conversationWith: "Cuộc trò chuyện với {name}",
  inboxConversation: "Cuộc trò chuyện trong Hộp thư",
  // `{link}` is "Unarchive the team" (a link for an admin).
  readOnlyBanner: "Kênh của nhóm đã lưu trữ · chỉ đọc. {link} để đưa các thành viên trở lại.",
  unarchiveTeam: "Bỏ lưu trữ nhóm",
  messageGone: "Tin nhắn đó không còn ở đây nữa.",
  newerFailed: "Không tải được các tin nhắn mới hơn.",
  mentionVantageSub: "đồng đội AI",
  mentionEveryoneSub: "mọi người ở đây",
  editFirst: "Hãy gửi hoặc xóa nội dung đang viết trước, rồi mới sửa.",
  editingMessage: "Đang sửa tin nhắn của bạn",
  editingLast: "Đang sửa tin nhắn cuối của bạn · câu trả lời sẽ được làm lại",
  reply: "Trả lời",
  messageTo: "Nhắn cho {name}",
  writeReply: "Viết câu trả lời…",
  askFollowUp: "Hỏi tiếp…",
  messageToShared: "Nhắn cho {name} — gõ @Vantage để hỏi trợ lý",
  askAnything: "Hỏi Vantage bất cứ điều gì…",
  relayHint:
    "Câu trả lời của bạn được gửi về nơi họ đã hỏi (thành viên của kênh sẽ thấy ở đó) · Bắt đầu bằng “Vantage,” nếu muốn hỏi Vantage",
  sharedHint: "@ để nhắc đến ai đó · # để chọn ticket · Enter để gửi · Shift+Enter để xuống dòng",

  // The composer.
  composerHint: "Enter để gửi · Shift+Enter để xuống dòng · Esc để dừng Vantage",
  composerDown: "Không tải được ô soạn tin. Hãy kiểm tra kết nối rồi tải lại trang.",
  noFilesWhileEditing: "Không thể thêm tệp khi đang sửa tin nhắn.",
  askForReport: "Yêu cầu một báo cáo…",
  didntSend: "Chưa gửi được. Hãy thử lại.",
  dropFiles: "Thả tệp vào đây để đính kèm",
  suggestions: "Gợi ý",
  uploading: "Đang tải lên {name}",
  removeFile: "Bỏ {name}",
  attachFiles: "Đính kèm tệp",
  mentionSomeone: "Nhắc đến ai đó",
  goDeep: "Phân tích sâu",
  goDeepTitle: "Để Vantage dành thời gian tìm hiểu thật kỹ",
  send: "Gửi",

  // The feed.
  olderFailed: "Không tải được các tin nhắn cũ hơn.",
  today: "Hôm nay · {date}",
  yesterday: "Hôm qua · {date}",
  newDivider: "Mới",
  jumpLatest: "Đến tin mới nhất",

  // The side panel: a thread.
  thread: "Luồng",
  threadAndNotes: "Luồng và ghi chú nhóm",
  sidePanel: "Bảng bên",
  summarize: "Tóm tắt",
  summarizeThread: "Tóm tắt luồng",
  summaryFailed: "Không yêu cầu tóm tắt được.",
  closePanel: "Đóng bảng bên",
  closeThread: "Đóng luồng",
  muteThread: "Tắt thông báo luồng",
  unmuteThread: "Bật lại thông báo luồng",
  muteTitle: "Tắt thông báo luồng này: chỉ hiện số chưa đọc, không gửi thông báo",
  mutedTitle: "Đã tắt thông báo: chỉ hiện số chưa đọc",
  threadMuted: "Đã tắt thông báo luồng: bạn chỉ thấy số chưa đọc",
  threadUnmuted: "Đã bật thông báo luồng",
  couldntChange: "Chưa đổi được lúc này.",
  replyGone: "Câu trả lời đó không còn ở đây nữa.",
  whatThreadRoot: "tin nhắn đầu tiên của luồng",
  whatReplies: "các câu trả lời",
  replies_one: "{n} câu trả lời",
  replies_other: "{n} câu trả lời",
  editingReply: "Đang sửa câu trả lời của bạn",
  replyInThread: "Trả lời trong luồng",
  replyInThreadPlaceholder: "Trả lời trong luồng…",

  // The side panel: files.
  closeFiles: "Đóng danh sách tệp",
  whatFiles: "danh sách tệp",
  filesEmpty:
    "Chưa có tệp nào. Các tệp được chia sẻ ở đây và báo cáo của Vantage sẽ hiện trong danh sách này.",
  deleteFile: "Xóa tệp",
  deleteFileTitle: "Xóa {name}?",
  deleteFileBody:
    "Tệp sẽ được gỡ khỏi mọi tin nhắn có đính kèm nó (nội dung tin nhắn vẫn giữ nguyên) và bị xóa cùng các bản xem trước. Không thể hoàn tác.",
  fileDeleted: "Đã xóa {name}.",
  fileDeleteFailed: "Không xóa được tệp.",

  // The side panel: team notes.
  whatNotes: "ghi chú",
  whatTeamNotes: "ghi chú nhóm",
  noNotes: "Chưa có ghi chú nhóm",
  notesListening:
    "Khi #{slug} trao đổi, Vantage sẽ ghi lại các quyết định, việc cần làm và câu hỏi còn mở ở đây.",
  notesNotListening: "Vantage không lắng nghe trong #{slug}, nên không ghi chú gì ở đây.",
  olderDone_one: "Đang ẩn {n} ghi chú đã xong cũ hơn.",
  olderDone_other: "Đang ẩn {n} ghi chú đã xong cũ hơn.",
  decisions: "Quyết định",
  actionItems: "Việc cần làm",
  openQuestions: "Câu hỏi còn mở",
  agoMoment: "vừa xong",
  agoMin: "{n} phút trước",
  agoHours: "{n} giờ trước",
  agoDays_one: "{n} ngày trước",
  agoDays_other: "{n} ngày trước",
  notesUpdated_one: "Cập nhật {ago} · từ {n} tin nhắn hôm nay",
  notesUpdated_other: "Cập nhật {ago} · từ {n} tin nhắn hôm nay",
  noOwnerYet: "Chưa có người phụ trách",
  noteDone: "đã xong",
  noteDue: "hạn {date}",
  askedAnswered: "Hỏi lúc {at} · đã trả lời",
  openSince: "Mở từ {at}",
  editNote: "Sửa ghi chú",
  showMessage: "Xem tin nhắn gốc",
  reopen: "Mở lại",
  markDone: "Đánh dấu đã xong",
  dismiss: "Bỏ qua",
  noteDismissed: "Đã bỏ qua ghi chú",
  noteChangeFailed: "Không đổi được ghi chú này.",
  noteRestoreFailed: "Không khôi phục được ghi chú.",
  addANote: "Thêm ghi chú",
  addNote: "Thêm ghi chú",
  noteAdded: "Đã thêm ghi chú",
  note: "Ghi chú",
  owner: "Người phụ trách",
  noOneYet: "Chưa có ai",
  dueDate: "Hạn chót",
  askAboutNotes: "Hỏi Vantage về các ghi chú này",
  notesQuestion: "Câu hỏi của bạn về các ghi chú này",
  notesQuestionPlaceholder: "Bạn muốn biết gì về các ghi chú này?",
  ask: "Hỏi",
  couldntAsk: "Chưa hỏi được lúc này.",

  // Vantage's tables.
  nounTicket: "ticket",
  nounTickets: "ticket",
  nounPullRequest: "pull request",
  nounPullRequests: "pull request",
  nounIssue: "issue",
  nounIssues: "issue",
  nounCommit: "commit",
  nounCommits: "commit",
  nounRun: "lượt chạy",
  nounRuns: "lượt chạy",
  nounDoc: "tài liệu",
  nounDocs: "tài liệu",
  nounPerson: "người",
  nounPeople: "người",
  nounNote: "ghi chú",
  nounNotes: "ghi chú",
  nounResult: "kết quả",
  nounResults: "kết quả",
  nounRow: "dòng",
  nounRows: "dòng",
  countAll: "{n} {noun}",
  countOf: "{stored}/{n} {noun}",
  countPlus: "{stored}+ {noun}",
  showAll: "Xem tất cả {n}",
  firstThousand: "Đang hiện 1.000 dòng đầu trong {n} dòng; tệp Excel có đủ tất cả.",
  allAsReport: "Cả {n} thành một báo cáo",
  allAsReportTitle: "Để Vantage dành thời gian lấy đủ mọi dòng",
  tableCopied: "Đã sao chép bảng",
  copyCode: "Sao chép mã",

  // An admin's trace of a turn.
  trace: "Trace",
  whatTrace: "trace",
  noModel: "không có model",
  traceTokens: "{in} vào · {out} ra · {cached} từ cache",
  step: "Bước",
  status: "Trạng thái",
  tokens: "Token",
  cost: "Chi phí",
  model: "Model",
  details: "Chi tiết",

  // A new chat.
  newChatAria: "Cuộc trò chuyện mới với Vantage",
  hi: "Chào {name}, mình có thể tra cứu gì cho bạn?",
  newChatIntro:
    "Hãy hỏi về ticket, pull request, tài liệu hoặc mọi người. Mình chỉ dùng những gì bạn được xem, và sẽ nói rõ mỗi câu trả lời lấy từ đâu.",
  starter1: "HoaVN có gì thay đổi trong tuần trước?",
  starter2: "Những pull request nào đang chờ review?",
  starter3: "Tìm checklist phát hành trong Outline",

  // A channel that isn't there.
  channel: "Kênh",
  channelGone: "Kênh này không còn truy cập được",
  channelGoneBody: "Có thể kênh đã được lưu trữ, hoặc bạn không ở trong nhóm của kênh.",
};
